__turbopack_context__.v({
  "checkboxFilterDropdownOption": "wOrcha_checkboxFilterDropdownOption",
  "content": "wOrcha_content",
  "divider": "wOrcha_divider",
  "dropdownsContainer": "wOrcha_dropdownsContainer",
  "fadein": "wOrcha_fadein",
  "filterAndSortContainer": "wOrcha_filterAndSortContainer",
  "filterCount": "wOrcha_filterCount",
  "filterOptionDisabled": "wOrcha_filterOptionDisabled",
  "filterWrapper": "wOrcha_filterWrapper",
  "filtersContainer": "wOrcha_filtersContainer",
  "filtersOpen": "wOrcha_filtersOpen",
  "flexGrow": "wOrcha_flexGrow",
  "footer": "wOrcha_footer",
  "footerButtonsContainer": "wOrcha_footerButtonsContainer",
  "header": "wOrcha_header",
  "hidden": "wOrcha_hidden",
  "mobileFilterButton": "wOrcha_mobileFilterButton",
  "roundedFooteButton": "wOrcha_roundedFooteButton",
  "searchFilterCheckbox": "wOrcha_searchFilterCheckbox",
  "searchFilterDropdownContents": "wOrcha_searchFilterDropdownContents",
  "searchFilterTrigger": "wOrcha_searchFilterTrigger",
  "searchFilterTriggerActive": "wOrcha_searchFilterTriggerActive",
  "searchFilterTriggerChevron": "wOrcha_searchFilterTriggerChevron",
  "searchFilterTriggerDisabled": "wOrcha_searchFilterTriggerDisabled",
  "searchFilterTriggerForward": "wOrcha_searchFilterTriggerForward",
  "searchFilterTriggerOpen": "wOrcha_searchFilterTriggerOpen",
  "searchFilterTriggerText": "wOrcha_searchFilterTriggerText",
  "sticky": "wOrcha_sticky",
});
